import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IDashboardStats,
  IDashboardStatsResponse,
} from '../types';
import {
  DASHBOARD_PERMISSIONS,
  DASHBOARD_STATS_QUERY_KEY,
  DASHBOARD_STATS_URL,
} from '../constants';

export default function useDashboardStatsQuery(merchant: Ref<number | undefined>): IContextQueryResult<IDashboardStatsResponse, Error, IDashboardStats> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IDashboardStatsResponse, Error, IDashboardStats>({
    queryKey: [DASHBOARD_STATS_QUERY_KEY, merchant],
    queryFn: ({ signal }) => fetchGet(DASHBOARD_STATS_URL, {
      signal,
      queryParams: { merchant: merchant.value },
      permission: DASHBOARD_PERMISSIONS.DASHBOARD_GET_STATS,
    }),
    select: (res) => res.stats ?? res.statistics,
    enabled: computed(() => !!merchant.value),
  });
}
